function formatStatus(status) {
  const key = String(status || "").trim().toLowerCase();
  if (key === "approved") return "Goedgekeurd";
  if (key === "rejected") return "Afgewezen";
  return "In afwachting";
}

function statusClassName(status) {
  const key = String(status || "").trim().toLowerCase();
  if (key === "approved") return "border-green-200 bg-green-50 text-green-700";
  if (key === "rejected") return "border-red-200 bg-red-50 text-red-700";
  return "border-amber-200 bg-amber-50 text-amber-700";
}

export default function ExtraTimeRequestButton({
  latestRequest,
  onClick,
  disabled = false,
}) {
  return (
    <div className="rounded border border-blue-100 bg-blue-50/60 p-3">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="space-y-1">
          <p className="text-sm font-semibold text-gray-900">Extra tijd nodig</p>
          <p className="text-xs text-gray-600">
            Vraag extra plantijd aan zonder de planning zelf te wijzigen.
          </p>
          {latestRequest && (
            <div className="flex flex-wrap items-center gap-2 pt-1">
              <span
                className={`rounded-full border px-2 py-1 text-[11px] font-medium ${statusClassName(
                  latestRequest.status
                )}`}
              >
                {formatStatus(latestRequest.status)}
              </span>
              <span className="text-xs text-gray-600">
                Laatste verzoek: +{latestRequest.requestedMinutes || 0} min
              </span>
            </div>
          )}
        </div>

        <button
          type="button"
          onClick={onClick}
          disabled={disabled}
          className="rounded bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-60"
        >
          Extra tijd nodig
        </button>
      </div>
    </div>
  );
}
